// extracted by mini-css-extract-plugin
export default {"__option":"answerOption___option__7KmNb","__option--correct":"answerOption___option--correct__cBCYR"};